import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-label font-medium mb-4">
            SEO Guides
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Vigorbuy Spreadsheet Guides &amp; Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            In-depth articles to help you master the vigorbuy spreadsheet and make smarter product decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group block bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                    <i className={`${article.icon} text-lg`}></i>
                  </div>
                  <span className="text-xs font-label text-foreground-500">{article.readTime}</span>
                </div>

                <h3 className="text-sm md:text-base font-label font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>

                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>

                <div className="flex items-center gap-1 mt-4 text-primary-500 text-xs font-label font-medium group-hover:gap-2 transition-all">
                  <span>Read Article</span>
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}